import * as types from './mutation-types'
import {createFormData} from "@/mixins/Helper.vue";
import {LOAD_DISCOUNT_TYPES} from "./mutation-types";


export const getCheckout = ({ commit, dispatch, state }, checkoutId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`edit/checkout/${checkoutId}`, { params: { checkout_id: checkoutId } }).then((response) => {
            commit(types.SET_CURRENT_ORDER, response.data);
            resolve(response);
        }).catch((err) => {
            reject(err);
        });
    });
};



export const setCheckoutDestockage = ({ commit, dispatch, state }, data) => {

    return new Promise((resolve, reject) => {

        window.axios.patch('update/checkout/' + data.checkout_id, data).then((response) => {
            dispatch('loadPendingOrdersCount')
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const getCheckoutStatusHistories = ({commit, dispatch, state}, checkout_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/checkout/' + checkout_id + '/status/histories').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const getCheckoutDeliveryNote = ({ commit, dispatch, state }, data) => {

    return new Promise((resolve, reject) => {

        window.axios.get('get/checkout/' + data.checkout_id + '/delivery/note').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
// data.silent : erreurs affichées par l'écran (fenêtre du code de remise), pas en toastr
export const updateCheckoutStatus = ({ commit, dispatch, state }, { silent, ...data }) => {

    return new Promise((resolve, reject) => {
        window.axios.patch('update/checkout/' + data.checkout_id+ '/status', data, { silent }).then((response) => {
            dispatch('loadPendingOrdersCount')
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getCheckoutShops = ({ commit, dispatch, state }, checkoutId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/checkout/shop/${checkoutId}`, { params: { checkout_id: checkoutId } }).then((response) => {
            resolve(response);
        }).catch((err) => {
            reject(err);
        });
    });
};

export const loadOrderStatus = ({commit, dispatch, state}) => {
    return new Promise((resolve, eject) => {
        window.axios.get('get/orders/status/list').then((response) => {
            resolve(response)
            commit(types.SET_ORDER_STATUS, response.data)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const loadReviewStatus = ({commit, dispatch, state}) => {
    return new Promise((resolve, eject) => {
        window.axios.get('get/review/status').then((response) => {
            resolve(response)
            commit(types.SET_REVIEW_STATUS, response.data)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const loadPlacesWithProduct = ({commit, dispatch, state}, productId) => {
    return new Promise((resolve, eject) => {
        window.axios.get(`get/product/${productId}/shops`).then((response) => {
            resolve(response)
            commit(types.SET_CURRENT_PRODUCT_PLACES, response.data)
        }).catch((err) => {
            eject(err)
        })
    })
}
export const previewDeliveryReceipt = ({ }, checkoutId) => {
    return new Promise((resolve, reject) => {
        axios({
            url: `delivery/note/pdf/checkout/${checkoutId}`,
            method: 'GET',
            responseType: 'blob', // nécessaire pour obtenir un Blob PDF
        })
            .then(response => {
                // Création d'un Blob avec le fichier PDF reçu
                const blob = new Blob([response.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob)
                resolve(url) // on renvoie l'URL à utiliser dans un iframe
            })
            .catch(error => {
                console.error('Erreur lors de la prévisualisation du bon de livraison :', error)
                reject(error)
            })
    })
}


export const getMyDeliveries = ({}, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/my/deliveries', { params }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getAllDeliveries = ({}, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/all/deliveries', { params }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

// data : l'id de la commande, ou { checkout_id, handover_code, collected_by } (code de remise du client)
export const markOrderAsDelivered = ({}, data) => {
    const { silent, ...body } = typeof data === 'object' ? data : { checkout_id: data }
    return new Promise((resolve, reject) => {
        window.axios.patch(`delivery/${body.checkout_id}/mark-delivered`, body, { silent }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadQuartiers = ({}, cityId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/${cityId}/quartiers`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getUsersForDelivery = ({}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/users/for/delivery').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getExternalDeliveryPersons = ({}, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/delivery/persons/external', { params }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createExternalDeliveryPerson = ({}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/delivery/person/external', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateExternalDeliveryPerson = ({}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/delivery/person/external/' + data.id, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const toggleExternalDeliveryPersonStatus = ({}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('delivery/person/external/' + id + '/status').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteExternalDeliveryPerson = ({}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delivery/person/external/' + id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const downloadDeliveryReceipt = ({ }, checkoutId) => {
    return new Promise((resolve, reject) => {
        axios({
            url: `delivery/note/pdf/checkout/${checkoutId}`,
            method: 'GET',
            responseType: 'blob', // nécessaire pour gérer le téléchargement de PDF
        })
            .then(response => {
                // Création d'un Blob avec le fichier PDF reçu
                const blob = new Blob([response.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob)

                // Création d'un lien pour déclencher le téléchargement du PDF
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `bon-livraison-${checkoutId}.pdf`)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)

                resolve(true)
            })
            .catch(error => {
                console.error('Erreur lors du téléchargement du bon de livraison :', error)
                reject(error)
            })
    })
}

// Nombre de commandes « En attente traitement » : alimente le point rouge du menu « Commandes »
export const loadPendingOrdersCount = ({ commit }) => {
    return window.axios.get('get/ecommerce/orders/pending/count').then((response) => {
        commit(types.SET_PENDING_ORDERS_COUNT, response.data?.count || 0)
        return response
    }).catch(() => {})
}
